export const ERROR_SIGN_IN = 'ERROR_SIGN_IN';
export const REQUEST_SIGN_IN = 'REQUEST_SIGN_IN';
export const SUCCESS_SIGN_IN = 'SUCCESS_SIGN_IN';

export const REQUEST_SIGN_OUT = 'REQUEST_SIGN_OUT';
export const SUCCESS_SIGN_OUT = 'SUCCESS_SIGN_OUT';

export const ERROR_SIGN_UP = 'ERROR_SIGN_UP';
export const REQUEST_SIGN_UP = 'REQUEST_SIGN_UP';
export const SUCCESS_SIGN_UP = 'SUCCESS_SIGN_UP';

export const AUTH_STATE_CHANGED = 'AUTH_STATE_CHANGED';

export const REQUEST_PASSWORD_RESET = 'REQUEST_PASSWORD_RESET';
export const SUCCESS_PASSWORD_RESET = 'SUCCESS_PASSWORD_RESET';
export const ERROR_PASSWORD_RESET = 'ERROR_PASSWORD_RESET';